// src/components/RPA/UploadDoc.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000/api';

const UploadDoc = ({ onUploaded }) => {
  const [projects, setProjects] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState('');
  const [kind, setKind] = useState('soc-report');
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  // Fetch accessible projects on mount
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axios.get(`${API_URL}/admin/rpa/projects`, {
          withCredentials: true
        });
        setProjects(res.data.projects || []);
      } catch (err) {
        console.error('[UploadDoc] Failed to fetch projects:', err);
        setMsg('Failed to load projects. Please refresh.');
      }
    };
    fetchProjects();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg('');

    if (!file) return setMsg('Please choose a file.');
    if (!selectedProjectId) return setMsg('Please select a project.');

    // Find selected project details
    const selectedProject = projects.find(p => p._id === selectedProjectId);
    if (!selectedProject) return setMsg('Invalid project selected.');

    // Optional: client-side file type validation
    if (!/^application\/(pdf|msword|vnd\.openxmlformats-officedocument\.wordprocessingml\.document)$|^text\/csv$|^application\/vnd\.(ms-excel|openxmlformats-officedocument\.spreadsheetml\.sheet)$/.test(file.type)) {
      return setMsg('Unsupported file type.');
    }

    try {
      setBusy(true);
      const form = new FormData();
      
      // Send project details
      form.append('projectId', selectedProjectId);
      form.append('client', selectedProject.client);
      form.append('project', selectedProject.name);
      form.append('kind', kind);
      form.append('file', file);

      await axios.post(`${API_URL}/admin/rpa/docs/upload`, form, {
        withCredentials: true,
        onUploadProgress: (evt) => {
          if (evt.total) {
            const pct = Math.round((evt.loaded / evt.total) * 100);
            // console.debug(`[RPA][UPLOAD] ${pct}%`);
          }
        }
      });

      setMsg('Upload complete.');
      setSelectedProjectId('');
      setKind('soc-report');
      setFile(null);
      if (typeof onUploaded === 'function') onUploaded();
    } catch (err) {
      console.error('[RPA] upload failed:', err);
      setMsg(err?.response?.data?.message || 'Upload failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={onSubmit} style={{ display: 'grid', gap: 10, maxWidth: 700 }}>
      <div style={{ display: 'grid', gap: 8, gridTemplateColumns: '1fr 1fr', alignItems: 'center' }}>
        
        <label>Project *</label>
        <select 
          value={selectedProjectId} 
          onChange={(e) => setSelectedProjectId(e.target.value)}
          required
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #d1d5db' }}
        >
          <option value="">Select Project</option>
          {projects.map(p => (
            <option key={p._id} value={p._id}>
              {p.client} - {p.name}
              {p.accessLevel === 'owner' ? ' 👑' : ' 🤝'}
            </option>
          ))}
        </select>

        <label>Document Type</label>
        <select 
          value={kind} 
          onChange={(e) => setKind(e.target.value)}
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #d1d5db' }}
        >
          <option value="soc-report">SOC Report</option>
          <option value="pbc">PBC</option>
          <option value="policy">Policy/Procedure</option>
          <option value="other">Other</option>
        </select>

        <label>File</label>
        <input
          type="file"
          onChange={(e) => setFile(e.target.files?.[0] || null)}
          accept=".pdf,.doc,.docx,.csv,.xlsx"
          required
          style={{ padding: '4px' }}
        />
      </div>

      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: '8px' }}>
        <button 
          type="submit" 
          disabled={busy}
          style={{
            background: busy ? '#9ca3af' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '6px',
            cursor: busy ? 'not-allowed' : 'pointer',
            fontWeight: '600'
          }}
        >
          {busy ? 'Uploading…' : 'Upload Document'}
        </button>
        {msg && (
          <span style={{ 
            fontSize: '14px', 
            color: msg.includes('complete') ? '#059669' : '#dc2626' 
          }}>
            {msg}
          </span>
        )}
      </div>

      {projects.length === 0 && (
        <div style={{ 
          padding: '12px', 
          background: '#fef3c7', 
          border: '1px solid #f59e0b', 
          borderRadius: '6px',
          fontSize: '14px',
          color: '#92400e'
        }}>
          No projects available. Create a project first in the Projects section above.
        </div>
      )}
    </form>
  );
};

export default UploadDoc;



// // src/components/admin/rpa/UploadDoc.js
// import React, { useState } from 'react';
// import axios from 'axios';

// const api = process.env.REACT_APP_API;

// const UploadDoc = ({ onUploaded }) => {
//   const [client, setClient] = useState('');
//   const [project, setProject] = useState('');
//   const [kind, setKind] = useState('soc-report'); // soc-report | pbc | policy | other
//   const [file, setFile] = useState(null);
//   const [busy, setBusy] = useState(false);
//   const [msg, setMsg] = useState('');

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setMsg('');

//     if (!file) return setMsg('Please choose a file.');
//     if (!client || !project) return setMsg('Client and Project are required.');

//     // Optional: small client-side validation
//     if (!/^application\/(pdf|msword|vnd\.openxmlformats-officedocument\.wordprocessingml\.document)$|^text\/csv$|^application\/vnd\.(ms-excel|openxmlformats-officedocument\.spreadsheetml\.sheet)$/.test(file.type)) {
//       return setMsg('Unsupported file type.');
//     }

//     try {
//       setBusy(true);
//       const form = new FormData();
//       form.append('client', client.trim());
//       form.append('project', project.trim());
//       form.append('kind', kind);
//       form.append('file', file); // field name MUST be "file" to match multer.single('file')

//       await axios.post(`${api}/admin/rpa/docs/upload`, form, {
//         withCredentials: true,
//         // IMPORTANT: do NOT set Content-Type; Axios adds the multipart boundary
//         onUploadProgress: (evt) => {
//           if (evt.total) {
//             const pct = Math.round((evt.loaded / evt.total) * 100);
//             // console.debug(`[RPA][UPLOAD] ${pct}%`);
//           }
//         }
//       });

//       setMsg('Upload complete.');
//       setClient('');
//       setProject('');
//       setKind('soc-report');
//       setFile(null);
//       if (typeof onUploaded === 'function') onUploaded();
//     } catch (err) {
//       console.error('[RPA] upload failed:', err);
//       setMsg(err?.response?.data?.message || 'Upload failed.');
//     } finally {
//       setBusy(false);
//     }
//   };

//   return (
//     <form onSubmit={onSubmit} style={{ display: 'grid', gap: 10, maxWidth: 700 }}>
//       <div style={{ display: 'grid', gap: 8, gridTemplateColumns: '1fr 1fr', alignItems: 'center' }}>
//         <label>Client</label>
//         <input value={client} onChange={(e) => setClient(e.target.value)} placeholder="e.g., HUD" required />
//         <label>Project</label>
//         <input value={project} onChange={(e) => setProject(e.target.value)} placeholder="e.g., FY25 SOC Read" required />
//         <label>Document Type</label>
//         <select value={kind} onChange={(e) => setKind(e.target.value)}>
//           <option value="soc-report">SOC Report</option>
//           <option value="pbc">PBC</option>
//           <option value="policy">Policy/Procedure</option>
//           <option value="other">Other</option>
//         </select>
//         <label>File</label>
//         <input
//           type="file"
//           onChange={(e) => setFile(e.target.files?.[0] || null)}
//           accept=".pdf,.doc,.docx,.csv,.xlsx"
//           required
//         />
//       </div>

//       <div style={{ display: 'flex', gap: 10 }}>
//         <button type="submit" disabled={busy}>{busy ? 'Uploading…' : 'Upload'}</button>
//         {msg && <span>{msg}</span>}
//       </div>
//     </form>
//   );
// };

// export default UploadDoc;

